import { PayPalButtonCreateOrder } from "@paypal/paypal-js"
import { getCart } from "src/checkout/hooks/useCart"
import { setExpressCheckoutErrorMessage } from "src/checkout/state/checkoutExpressStore"
import { action_createPayPalOrder } from "src/integrations/paypal/actions"
import { paypalLogPrefix } from "src/integrations/paypal/constants"
import { genericErrorMessage } from "src/utilities/errorMessages"
import { recordError } from "src/utilities/errorReporting"

export const payPalButtonCreateOrder: PayPalButtonCreateOrder = async (data, actions) => {
  try {
    console.debug(paypalLogPrefix, "createOrder", data, actions)

    const cart = getCart()!
    const response = await action_createPayPalOrder(cart)
    console.debug(paypalLogPrefix, "createOrder action_createPayPalOrder", response)

    const paypalOrder = response.result
    const orderId = paypalOrder.id

    if (!orderId) {
      throw new Error("Failed to create PayPal order")
    }

    return orderId
  } catch (error) {
    recordError(paypalLogPrefix + " Failed to handle createOrder", error)
    setExpressCheckoutErrorMessage(genericErrorMessage)
    throw error
  }
}
